import { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Avatar,
  List,
  Tooltip,
  Divider,
  ListItemAvatar,
  ListItemText,
  Card,
  Grid,
  ListItem,
  CssBaseline,
  BottomNavigation,
  Stack,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  FormHelperText
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import SnackbarAlert from '../common/SnackbarAlert';
import loaderGif from '../common/no_bg_loader.gif';
import FileImage from '../common/document.jpg';
import NewNote from '../common/new_note.png';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import TaskIcon from '@mui/icons-material/Task';
// import InfiniteScroll from 'react-infinite-scroll-component';
import * as React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { styled } from '@mui/material/styles';
import AttachFileTwoToneIcon from '@mui/icons-material/AttachFileTwoTone';
import Link from '@mui/material/Link';
import { LoadingButton } from '@mui/lab';
import LinkIcon from '@mui/icons-material/Link';
import request from 'src/utils/request';
import moment from 'moment';
import { checkPermission } from '../../utils/permission';
import NoPermissionContent from '../common/NoPermissionContent';
import NoDataAvailable from '../common/NoDataAvailable';

// import { ConstructionOutlined } from '@mui/icons-material';
const DividerWrapper = styled(Divider)(
  ({ theme }) => `
        height: 2px !important;
        margin: 0 ${theme.spacing(1)};
        align-self: center;
`
);

const Input = styled('input')({
  display: 'none'
});

function NotesChatList({ pageNoteType = null, noteTypeDatas = null }) {
  const fileRef = useRef(null);
  const [supportingFile, SetSupportingFile] = useState('.jpg, .jpeg, .png');

  const EnquirySchema = Yup.object().shape({
    description: Yup.string().required('Note is required'),
    file: Yup.mixed()

      .test('is-file-of-correct-type', 'Unsupported file format', () => {
        let valid = true;
        const files = fileRef?.current?.files;
        if (files) {
          const fileArr = Array.from(files);
          fileArr.forEach((file: any) => {
            const type = file.type.split('/')[1];
            console.log(type);
            const validTypes = ['jpeg', 'png', 'jpg'];
            if (!validTypes.includes(type)) {
              valid = false;
            }
            console.log(valid);
          });
        }
        return valid;
      })
      .test(
        'FILE_SIZE',
        'Uploaded file is too big. Max size is 3MB',
        (values) => {
          let valid = true;
          if (values?.size) {
            if (values && values.size <= 3000000) {
              valid = true;
            } else {
              valid = false;
            }
          }

          return valid;
        }
      )
  });
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const [noteType, setNoteType] = useState(null);
  const [status, setStatus] = useState(false);
  const [noteId, setNoteId] = useState(null);
  const [loader, setLoader] = useState(null);
  const [pageLoader, setPageLoader] = useState(false);
  const [noteDatas, setNoteDatas] = useState([]);
  const [uploadedFileDatas, setUploadedFileDatas] = useState('');
  const [uploadedFileType, setUploadedFileType] = useState('');
  const [totalCount, setTotalCount] = useState<number>(0);
  const [selectedTaskId, setSelectedTaskId] = useState('None');

  //Permission Check
  const [noteViewPermission, setNoteViewPermission] = useState(false);
  const [noteCreatePermission, setNoteCreatePermission] = useState(false);
  const [fileValue, setFileValue] = useState('');
  const [hasBeenClicked, setHasBeenClicked] = useState<boolean>(false);
  const [flag, setFlag] = useState<boolean>(false);



  useEffect(() => {
    checkNotesPermission();
  }, []);

  const checkNotesPermission = async () => {
    await checkPermission('notes', 'view').then((permission) => {
      setNoteViewPermission(permission);
    });
    await checkPermission('notes', 'create').then((permission) => {
      setNoteCreatePermission(permission);
    });
  };
  //#End
  useEffect(() => {
    setNoteDatas([]);
    setTotalCount(0);
    setStatus(!status);
  }, [noteType]);

  useEffect(() => {
    setNoteType(pageNoteType);
    let noteid = null;
    if (pageNoteType === 'Enquiry') {
      noteid = noteTypeDatas.id;
    }
    if (pageNoteType === 'Requirement') {
      noteid = noteTypeDatas.id;
    }
    if (pageNoteType === 'Task') {
      noteid = noteTypeDatas.id;
    }
    if (pageNoteType === 'Lead') {
      noteid = noteTypeDatas.id;
    }
    if (pageNoteType === 'ClaimRequest') {
      noteid = noteTypeDatas.id;
    }
    if (pageNoteType === 'RFQ') {
      noteid = 0;
      pageNoteType = 'Task';
      setNoteType('Task');
    }
    setNoteId(noteid);
    getNotes(pageNoteType, noteid);
  }, []);

  const getNotes = async (pageNoteType, noteid) => {
    setPageLoader(true);
    request({
      url: 'enquiryNote/getEnquiryNoteList',
      method: 'post',
      data: {
        id: parseInt(noteid),
        type: pageNoteType,
        orderColumn: 'id',
        orderDirection: 'DESC'
      }
    }).then(
      (response) => {
        setPageLoader(false);
        // if (offset > 0) {
        //   setNoteDatas(noteDatas.concat(response['EnquiryNoteData']));
        // } else {
        setNoteDatas(response['EnquiryNoteData']);
        // }
        setTotalCount(response['EnquiryNoteCount']);
        setStatus(!status);
      },
      (error) => {
        setPageLoader(false);
      }
    );
  };

  const formik = useFormik({
    initialValues: {
      id: '',
      enquiryId: 0,
      requirementId: 0,
      taskId: 0,
      description: '',
      file: ''
    },
    validationSchema: EnquirySchema,
    onSubmit: async (data) => {
      if (noteId === 0 || noteId === 'None') {
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: 'Please select any task'
        });
        return;
      }
      setLoader(true);
      const formData = new FormData();
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      };
      formData.append('id', noteId as unknown as string);
      formData.append('type', noteType);
      formData.append('description', data.description);
      formData.append('file', uploadedFileDatas);
      await request
        .post('enquiryNote/create', formData, config)
        // eslint-disable-next-line
        .then((response) => {
          setLoader(false);
          formik.resetForm();
          setUploadedFileDatas(null);
          setUploadedFileType('');
          
          setFileValue('');
          setFlag(false);
          setHasBeenClicked(false);
          getNotes(noteType, noteId);
        })
        .catch((error) => {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: error['message']
          });
          setLoader(false);
        });
    }
  });

  const handleFileInput = (file) => {
    setFileValue(file.target.value);
    const fileData = file.target.files[0];
    formik.setFieldValue('file', file.target.files[0]);
    setUploadedFileDatas(fileData);
    setUploadedFileType(fileData?.type);
    if (!formik.values.file) {
      formik.setFieldError('file', 'File is required');
    }
  };

  const removeSelectedFile = () => {
    setUploadedFileDatas('');
    setUploadedFileType('');
    formik.errors.file='';
    formik.setFieldValue('file','');
    formik.setFieldError('file', '');
    setFileValue('');


  };

  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const userData = JSON.parse(localStorage.getItem('userDatas'));

  // const fetchMoreData = () => {
  //   console.log('fetchMore....');
  //   setOffset(offset + 1);
  // };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  const handleFocus = (fileInput) => {
    // Skip the first onFocus
    setHasBeenClicked(true);
    if (hasBeenClicked && fileInput.value.length === 0) {
      setFlag(true);
      formik.setFieldError('file', 'File is required');
    }
  };

  return (
    <div>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      {!noteCreatePermission ? (
        <Grid item xs={12} mr={2}>
          <NoPermissionContent />
        </Grid>
      ) : (
        <Card
          sx={{
            display: 'block',
            alignItems: 'center',
            p: 2,
            mr: 2,
            backgroundColor: 'rgba(9, 84, 174, 0.05)',
            borderRadius: '8px 8px 0px 0px !important'
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={1}>
              <Grid item xs={2}>
                <Avatar
                  src={userData.userData.photo}
                  sx={{ width: 56, height: 56 }}
                />
              </Grid>

              <Grid item xs={10}>
              
                <TextField
                  className="text-box"
                  hiddenLabel
                  fullWidth
                  type="text-area"
                  multiline
                  rows={4}
                  label={
                    <React.Fragment>
                      Create Note{' '}
                      <Typography component="span" sx={{ color: 'red' }}>
                        *
                      </Typography>
                    </React.Fragment>
                  }
                  value={formik.values.description}
                  name="description"
                  onChange={formik.handleChange}
                  error={
                    formik.touched.description &&
                    Boolean(formik.errors.description)
                  }
                  // helperText={
                  //   formik.touched.description && formik.errors.description
                  // }
                />
                <FormHelperText
                  error={
                    formik.touched.description &&
                    Boolean(formik.errors.description)
                  }
                >
                  {formik.touched.description && formik.errors.description
                    ? formik.errors.description
                    : ''}
                </FormHelperText>
              </Grid>
              <Grid item xs={12} sx={{ml:10.5}}>
              <FormControl size="small" fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginTop: 20 }}
                        
                      >
                        Select File (JPG,JPEG,PNG|File size 3MB)
                      </InputLabel>

                      <input
                        id="standard-basic"
                        name="file"
                        accept={supportingFile}
                        ref={fileRef}
                        type="file"
                        onFocus={(e) => {
                          setTimeout(() => {
                            handleFocus(e.target);
                          }, 250);
                        }}
                        value={fileValue}
                        onChange={(e) => {
                          handleFileInput(e);
                        }}

                        // helperText={
                        //   flag ||
                        //   // formik.errors.file ===
                        //   //   'Uploaded file has unsupported format' ||
                        //   (formik.touched.file && formik.errors.file)
                        // }
                      />
                      <FormHelperText
                        error={Boolean(formik.errors.file)}
                        style={{ zIndex: '9999', marginTop: 30 }}
                        
                      >
                        {formik.errors.file}
                      </FormHelperText>
                    </FormControl>
              </Grid>
              <Grid item xs={12}  sx={{ml:10.5}}>
              {uploadedFileDatas ? (
                  <>
                    {uploadedFileType.includes('image') ? (
                      <img
                        alt="loader"
                        src={URL.createObjectURL(uploadedFileDatas)}
                        className="loader"
                        width={150}
                        height={100}
                      />
                    ) : (
                      <img
                        alt="loader"
                        src={FileImage}
                        className="loader"
                        width={100}
                        height={100}
                      />
                    )}
                    <Tooltip arrow placement="top" title="Remove File">
                      <DeleteIcon
                        color="error"
                        sx={{ cursor: 'pointer' }}
                        onClick={removeSelectedFile}
                      />
                    </Tooltip>
                  </>
                ) : null}
              </Grid>
              <br />
              <Grid item xs={12} sx={{ml:27,mt:2}}>
                <LoadingButton
                  sx={{ mt: { xs: 2, md: 0 }, marginRight: '2%' }}
                  loading={loader}
                  variant="contained"
                  type="submit"
                >
                  Add
                </LoadingButton>
              </Grid>
            </Grid>
            <DividerWrapper orientation="vertical" flexItem />
          </form>
        </Card>
      )}
      {!noteViewPermission ? (
        <Grid item xs={12} mr={2} mt={1}>
          <NoPermissionContent />
        </Grid>
      ) : (
        <>
          <Card
            sx={{
              display: 'block',
              alignItems: 'center',
              p: 2,
              mr: 2,
              borderRadius: '0px 0px 0px 0px !important'
            }}
          >
            <Box mt={1}>
              <CssBaseline />
              {pageNoteType === 'RFQ' && noteType === 'Task' ? (
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Task
                  </InputLabel>
                  <Select
                    size="small"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedTaskId}
                    label="Select Task"
                    onChange={(event) => {
                      setSelectedTaskId(event.target.value);
                      setNoteType('Task');
                      setNoteId(event.target.value);
                      getNotes(
                        'Task',
                        event.target.value === 'None' ? 0 : event.target.value
                      );
                    }}
                  >
                    <MenuItem value="None">Select Task</MenuItem>
                    {noteTypeDatas.taks?.map((taskData) => {
                      return (
                        <MenuItem value={taskData.id}>
                          {taskData.uniquecode}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              ) : null}
              <div id="scrollableDiv" style={{ height: 250, overflow: 'auto' }}>
                {totalCount <= 0 && pageLoader === false ? (
                  <NoDataAvailable />
                ) : null}

                {pageLoader ? (
                  <Stack
                    sx={{ color: 'grey.500', mt: 5 }}
                    spacing={2}
                    direction="row"
                    justifyContent="center"
                  >
                    <img
                      alt="loader"
                      src={loaderGif}
                      className="loader"
                      width={100}
                      height={100}
                    />
                  </Stack>
                ) : null}

                {/* <InfiniteScroll
      dataLength={noteDatas.length}
      next={fetchMoreData}
      hasMore={noteDatas.length > 0}
      loader={
        totalCount !== noteDatas.length ? (
          <Stack
            sx={{ color: 'grey.500' }}
            spacing={2}
            direction="row"
            justifyContent="center"
          >
            <img
              alt="loader"
              src={loaderGif}
              className="loader"
              width={50}
              height={50}
            />
          </Stack>
        ) : null
      }
      scrollableTarget="scrollableDiv"
    > */}
                {noteDatas?.map((note) => {
                  return (
                    <List
                      sx={{
                        width: '100%',
                        maxWidth: 500,
                        bgcolor: 'background.paper'
                      }}
                      key={note.id}
                    >
                      <>
                        <ListItem alignItems="flex-start">
                          <ListItemAvatar>
                            <Avatar
                              src={note.user.photo}
                              sx={{ width: 40, height: 40 }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={`${note.user.firstName} ${note.user.lastName}`}
                            sx={{ variant: 'h4', color: 'black' }}
                            secondary={
                              <React.Fragment>
                                <Typography
                                  sx={{ display: 'inline' }}
                                  component="span"
                                  variant="body2"
                                  color="text.primary"
                                >
                                  {note.description}
                                </Typography>
                                {note['EnquiryNoteAttachment'] ? (
                                  <>
                                    <List disablePadding component="div"></List>
                                    <Link>
                                      <Tooltip
                                        title="View Attachment"
                                        arrow
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <LinkIcon
                                          onClick={() =>
                                            openInNewTab(
                                              note['EnquiryNoteAttachment']
                                                .filePath
                                            )
                                          }
                                        />
                                      </Tooltip>
                                    </Link>
                                  </>
                                ) : null}
                                <List disablePadding component="div"></List>
                                {moment(note.createdAt).fromNow()}
                              </React.Fragment>
                            }
                          />
                        </ListItem>
                        <DividerWrapper
                          sx={{ length: '250%' }}
                        ></DividerWrapper>
                      </>
                    </List>
                  );
                })}
                {/* </InfiniteScroll> */}
              </div>
            </Box>
          </Card>
          {/* <Card
            sx={{
              display: 'block',
              alignItems: 'center',
              p: 2,
              mr: 2,
              borderRadius: '0px 0px 8px 8px !important',
              boxShadow: '0px -2px 4px rgba(0, 0, 0, 0.1)'
            }}
          >
            {pageNoteType !== 'ClaimRequest' ? (
              <>
                {pageNoteType === 'Enquiry' ? (
                  <BottomNavigation showLabels value={0}>
                    <BottomNavigationAction
                      label="Enquiry"
                      icon={<NotificationImportantIcon />}
                    />
                  </BottomNavigation>
                ) : pageNoteType === 'Requirement' ? (
                  <BottomNavigation
                    showLabels
                    value={noteType === 'Enquiry' ? 0 : 1}
                  >
                    <BottomNavigationAction
                      label="Enquiry"
                      onClick={() => {
                        setNoteType('Enquiry');
                        setNoteId(noteTypeDatas.enquiryId);
                        getNotes('Enquiry', noteTypeDatas.enquiryId);
                      }}
                      icon={<NotificationImportantIcon />}
                    />
                    <BottomNavigationAction
                      label="Requirement"
                      onClick={() => {
                        setNoteType('Requirement');
                        setNoteId(parseInt(noteTypeDatas.id));
                        getNotes('Requirement', noteTypeDatas.id);
                      }}
                      icon={<AssignmentLateIcon />}
                    />
                  </BottomNavigation>
                ) : pageNoteType === 'Task' ? (
                  <BottomNavigation
                    showLabels
                    value={
                      noteType === 'Enquiry'
                        ? 0
                        : noteType === 'Requirement'
                        ? 1
                        : 2
                    }
                  >
                    <BottomNavigationAction
                      label="Enquiry"
                      icon={<NotificationImportantIcon />}
                      onClick={() => {
                        setNoteType('Enquiry');
                        setNoteId(parseInt(noteTypeDatas.enquiryId));
                        getNotes('Enquiry', noteTypeDatas.enquiryId);
                      }}
                    />
                    <BottomNavigationAction
                      label="Requirement"
                      icon={<AssignmentLateIcon />}
                      onClick={() => {
                        setNoteType('Requirement');
                        setNoteId(parseInt(noteTypeDatas.requirementId));
                        getNotes('Requirement', noteTypeDatas.requirementId);
                      }}
                    />

                    <BottomNavigationAction
                      label="Task"
                      icon={<TaskIcon />}
                      onClick={() => {
                        setNoteType('Task');
                        setNoteId(parseInt(noteTypeDatas.id));
                        getNotes('Task', noteTypeDatas.id);
                      }}
                    />
                  </BottomNavigation>
                ) : pageNoteType === 'Lead' ? null : (
                  <BottomNavigation
                    showLabels
                    value={
                      noteType === 'Enquiry'
                        ? 0
                        : noteType === 'Requirement'
                        ? 1
                        : 2
                    }
                  >
                    <BottomNavigationAction
                      label="Enquiry"
                      icon={<NotificationImportantIcon />}
                      onClick={() => {
                        setNoteType('Enquiry');
                        setNoteId(parseInt(noteTypeDatas.enquiryId));
                        getNotes('Enquiry', noteTypeDatas.enquiryId);
                      }}
                    />
                    <BottomNavigationAction
                      label="Requirement"
                      icon={<AssignmentLateIcon />}
                      onClick={() => {
                        setNoteType('Requirement');
                        setNoteId(parseInt(noteTypeDatas.id));
                        getNotes('Requirement', noteTypeDatas.id);
                      }}
                    />

                    <BottomNavigationAction
                      label="Task"
                      icon={<TaskIcon />}
                      onClick={() => {
                        setNoteType('Task');
                        setNoteId(0);
                        setSelectedTaskId('None');
                        getNotes('Task', 0);
                      }}
                    />
                  </BottomNavigation>
                )}
              </>
            ) : null}
          </Card> */}
        </>
      )}
    </div>
  );
}

export default NotesChatList;
